import type {DivProps} from "@/common/Div/Div.types";
import type {FC} from "react";

import * as Styled from "@/common/Div/Div.style";

export const Div: FC<DivProps> = ({children, ...rest}) => {
    return <Styled.Div {...rest}>{children}</Styled.Div>;
};
